/** The money card's notice that Stripe could not be reached. */
export default function ReviewStripeDown({ paymentIntentId }: { paymentIntentId: string | null }) {
  return (
    <div
      style={{
        background: 'var(--nb-warn-soft)',
        borderRadius: 10,
        padding: '11px 13px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--nb-warn)' }}>
        Couldn&apos;t reach Stripe
      </div>
      <div style={{ fontSize: 11.5, lineHeight: 1.5, color: 'var(--nb-ink-2)' }}>
        Authorized, captured and refunded amounts are unavailable right now. Everything above is our
        own record and is unaffected — open the payment in Stripe directly to confirm.
      </div>
      {paymentIntentId && (
        <div className="nb-mono" style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>
          {paymentIntentId}
        </div>
      )}
    </div>
  );
}
